import { ProducerTile } from 'producer';
import React from 'react';
import './ProducerGrid.scss';
function ProducerGrid({ producers, hideImages }) {
    return (React.createElement("div", { className: "producer-grid" }, producers === null || producers === void 0 ? void 0 : producers.map((producer) => (React.createElement(ProducerTile, { key: producer.slug, producer: producer, hideImage: hideImages })))));
}
export default ProducerGrid;
